import React from "react";

function CodeIcon() {
  return (
    <svg
      width="24px"
      height="24px"
      viewBox="0 -2 30 30"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        strokeWidth="1"
        fillRule="evenodd"
        transform="translate(-257.000000, -726.000000)"
      >
        <path d="M286.717,738.531 L280.726,733.688 C280.332,733.304 279.693,733.304 279.3,733.688 C278.906,734.072 278.906,734.694 279.3,735.079 L284.491,739.276 L279.3,743.474 C278.906,743.857 278.906,744.48 279.3,744.864 C279.693,745.249 280.332,745.249 280.726,744.864 L286.717,740.021 C286.927,739.816 287.016,739.544 287.002,739.276 C287.016,739.008 286.927,738.735 286.717,738.531 L286.717,738.531 Z M264.7,743.473 L259.509,739.276 L264.7,735.079 C265.094,734.694 265.094,734.071 264.7,733.688 C264.307,733.303 263.668,733.303 263.274,733.688 L257.283,738.531 C257.073,738.735 256.984,739.008 256.998,739.276 C256.984,739.544 257.073,739.816 257.283,740.021 L263.274,744.864 C263.668,745.249 264.307,745.249 264.7,744.864 C265.094,744.48 265.094,743.857 264.7,743.473 L264.7,743.473 Z M278.96,726.123 C278.481,725.852 277.87,726.013 277.594,726.481 L265.094,750.568 C264.817,751.037 264.932,751.754 265.46,751.907 C266.105,752.094 266.55,752.018 266.826,751.549 L279.326,727.461 C279.602,726.992 279.438,726.394 278.96,726.123 L278.96,726.123 Z" />
      </g>
    </svg>
  );
}

export default CodeIcon;
